import type { ReactNode } from 'react';
import { cn } from '../lib/utils.js';
import {
  Card,
  CardAction,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from './ui/card.js';

export interface SectionCardProps {
  title: string;
  description?: string;
  /** Right-aligned control in the header — "View all", a filter, a menu. */
  action?: ReactNode;
  children: ReactNode;
  /** Remove the content padding, for a card whose body is a table or list. */
  flush?: boolean;
  className?: string;
}

/**
 * A titled panel. `AdminDashboardPage` previously inlined
 * `rounded-[14px] border border-border bg-card` plus a header row instead of using `Card`,
 * because the raw `Card` had no header-with-action shape. This is that shape.
 */
export function SectionCard({
  title,
  description,
  action,
  children,
  flush = false,
  className,
}: SectionCardProps) {
  return (
    <Card className={cn('gap-0 py-0', className)}>
      <CardHeader className="border-b border-border py-4">
        <CardTitle className="text-[14px]">{title}</CardTitle>
        {description && <CardDescription>{description}</CardDescription>}
        {action && <CardAction>{action}</CardAction>}
      </CardHeader>
      <CardContent className={cn(flush ? 'px-0 py-0' : 'py-4')}>{children}</CardContent>
    </Card>
  );
}
